import { BasicMachineInformationStruct } from "../../common/Interfaces";
import axios from "axios";

interface BasicMachineInformationParams {
  serialNumber: string;
  token: string | null
}

export const fetchBasicMachineInformations = async ({serialNumber, token}: BasicMachineInformationParams) => {    
    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };
    const apiResponse = await axios.get(
        process.env.REACT_APP_SIM_BASE_URL + "/v1/BasicMachineInformation/SerialNumber/Search/" + serialNumber,
        config
    );
    const basicMachineInformationList: BasicMachineInformationStruct[] = apiResponse.data.map((basicMachineInformation: any) => ({
        productCompanyCode: basicMachineInformation.productCompanyCode,
        productRange: basicMachineInformation.productRange ? basicMachineInformation.productRange.description : null,
        model:  {
            key: basicMachineInformation.model? basicMachineInformation.model.code : null,
            label: basicMachineInformation.model? basicMachineInformation.model.description : null,
        },
        productNumbers: basicMachineInformation.productNumbers,
        serialNumber: basicMachineInformation.serialNumber,
    }));
    return basicMachineInformationList;
}
